﻿import React from "react";
import Spinner from 'react-bootstrap/Spinner';
import CSS from 'csstype';

interface BypassPrechatFormProps {    
    tenantId: string;
    email?: string;
    username?: string;
    startChat(userInfo: IUserInfo): any;
}

export interface IUserInfo {
    username: string;
    tenantId: string;
    email: string;
    metadata: Map<string, string>;
}

const spinnerStyle: CSS.Properties = {
    'margin': '100px 0 0 calc(50% - 1rem)'
}


class BypassPrechatForm extends React.Component {
    private tenantId: string;    
    private startChat: any;
    readonly props: BypassPrechatFormProps;

    constructor(props: BypassPrechatFormProps) {
        console.log(">> BypassPrechatForm Constructor")
        super(props);
        this.props = props;
        this.tenantId = props.tenantId;

        if (props.startChat) {
            const metadata = new Map<string, string>();
            if (props.username) {
                metadata.set("Guest.GivenName", props.username.split(" ")[0] || "Web");
                metadata.set("Guest.Surname", props.username.split(" ")[1] || "Visitor");
            } else {
                metadata.set("Guest.GivenName", "Web");
                metadata.set("Guest.Surname", "Visitor");
            }
            
            this.startChat = props.startChat({
                username: props.username || "Web Visitor",
                tenantId: this.tenantId,
                email: props.email || "webvisitor@example.com",                
                metadata: metadata
            });
        }
    }    

    render(): any {
        return (
            <Spinner animation="border" role="status" style={spinnerStyle}>
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        );
    }
} 

 export default BypassPrechatForm;